export const env = {
  kenticoAssetURL: process.env.kenticoAssetURL,
  clientId: process.env.clientId,
  clientSecret: process.env.clientSecret,
  credstoreKongUtilsServiceBasicAuthToken:
    process.env.credstoreKongUtilsServiceBasicAuthToken,
  hcidExtrnalApiBaseUrl: process.env.hcidExtrnalApiBaseUrl,
  kongBasicAuthToken: process.env.kongBasicAuthToken,
  MAGNOLIA_URL: process.env.MAGNOLIA_URL,
  BASE_MAGNOLIA_REST_URL: process.env.BASE_MAGNOLIA_REST_URL,
  BASE_MAGNOLIA_IMAGING_URL: process.env.BASE_MAGNOLIA_IMAGING_URL,
  baseUrl: process.env.baseUrl,
  auth: process.env.auth,
  APP_POS_LOCATOR_API_URL: process.env.APP_POS_LOCATOR_API_URL,
  APP_OPEN_STREET_MAP_API_URL: process.env.APP_OPEN_STREET_MAP_API_URL,
  APP_WEBSITE_URL: process.env.APP_WEBSITE_URL,
  APP_PARTNER_PORTAL_API_URL: process.env.APP_PARTNER_PORTAL_API_URL,
};
